export default __webpack_public_path__ + "static/media/prepare-an-interview-guideline.fc1d6810.pdf";